import { render, staticRenderFns } from "./ContractStrandards.vue?vue&type=template&id=3bd380bc&scoped=true&"
import script from "./ContractStrandards.vue?vue&type=script&lang=js&"
export * from "./ContractStrandards.vue?vue&type=script&lang=js&"
import style0 from "./ContractStrandards.vue?vue&type=style&index=0&id=3bd380bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd380bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
